import React from 'react';

const Block = ({ className = '' }) => <span className={`manage-profile-skeleton-block ${className}`.trim()} />;

export default function ManageProfileSkeleton() {
  return (
    <div className="manage-profile-page manage-profile-skeleton" aria-busy="true" aria-label="Loading profile">
      <div className="profile-sub-container">
        <div className="left-panel">
          <div className="profile-pic-container">
            <Block className="manage-profile-skeleton-avatar" />
          </div>
          <Block className="manage-profile-skeleton-name" />
          <Block className="manage-profile-skeleton-status" />
          <Block className="manage-profile-skeleton-bio" />
          <ul className="manage-profile-skeleton-nav">
            {[1, 2, 3, 4, 5].map((i) => (
              <li key={i}>
                <Block className="manage-profile-skeleton-nav-item" />
              </li>
            ))}
          </ul>
        </div>
        <div className="right-panel">
          <div className="right-content manage-profile-fields">
            <Block className="manage-profile-skeleton-heading" />
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="form-group">
                <Block className="manage-profile-skeleton-label" />
                <Block className="manage-profile-skeleton-input" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
